export default {
  methods: {
    getDom: function getDom() {
      return document.querySelector('#design-middle-layout');
    }
  }
};